<script setup lang="ts">
  import { Menu as ArkMenu } from '@ark-ui/vue';
  import { computed, useId } from 'vue';
  import FontIcon from '../../FontIcon/FontIcon.vue';
  import {
    itemClass,
    itemDescriptionClass,
    itemDisabledClass,
    itemIconClass,
    itemLabelClass,
    itemLabelWithDescriptionClass,
    itemTextClass,
  } from './DropdownMenuItem.css';
  import type {
    DropdownMenuItemEmits,
    DropdownMenuItemProps,
  } from './DropdownMenuItem.types';

  defineOptions({ inheritAttrs: false });

  const props = defineProps<DropdownMenuItemProps>();

  const emit = defineEmits<DropdownMenuItemEmits>();

  const value = useId();

  const classes = computed(() => [
    itemClass,
    { [itemDisabledClass]: props.disabled },
  ]);

  const labelClasses = computed(() => [
    itemLabelClass,
    { [itemLabelWithDescriptionClass]: !!props.description },
  ]);

  const onClick = (event: MouseEvent) => {
    if (props.disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    emit('click', event);
  };
</script>

<template>
  <ArkMenu.Item
    as-child
    :value="value"
    :value-text="label"
    :disabled="disabled"
  >
    <button
      type="button"
      :class="classes"
      :data-testid="testId"
      v-bind="$attrs"
      @click="onClick"
    >
      <span v-if="icon" :class="itemIconClass">
        <FontIcon :icon-name="icon" />
      </span>
      <span :class="itemTextClass">
        <span :class="labelClasses">{{ label }}</span>
        <span v-if="description" :class="itemDescriptionClass">
          {{ description }}
        </span>
      </span>
    </button>
  </ArkMenu.Item>
</template>
